import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">🔮 Ball Sort <span className="accent">Master</span></Link>
          <p>A free, beautiful color-sorting puzzle game. Train your brain, beat every level, and enjoy the satisfying glow of perfectly sorted tubes.</p>
        </div>
        <div className="footer-col">
          <h4>Game</h4>
          <ul>
            <li><Link to="/#play">▶ Play Now</Link></li>
            <li><Link to="/#how">How to Play</Link></li>
            <li><Link to="/#features">Features</Link></li>
            <li><Link to="/#article">Strategy Guide</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Puzzle Types</h4>
          <ul>
            <li><span style={{color:'rgba(255,255,255,0.4)', fontSize:'0.875rem'}}>🎯 Logic Puzzles</span></li>
            <li><span style={{color:'rgba(255,255,255,0.4)', fontSize:'0.875rem'}}>🧩 Color Sort</span></li>
            <li><span style={{color:'rgba(255,255,255,0.4)', fontSize:'0.875rem'}}>🧠 Brain Games</span></li>
            <li><span style={{color:'rgba(255,255,255,0.4)', fontSize:'0.875rem'}}>📱 Mobile Friendly</span></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Ball Sort Master. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
